<template>
  <div
    class="btn"
    :class="[props.type, { disabled: props.disabled }]"
    @click="handleClick"
  >
    <slot></slot>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'blue', // yellow, blue
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click'])

const handleClick = (e) => {
  if (props.disabled) return
  emit('click', e)
}
</script>

<style lang="less" scoped>
.btn {
  min-width: 250px;
  height: 76px;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #fff;
  background: linear-gradient(to bottom, #FEE567, #FFFEBE);
  border-top-left-radius: 15px;
  border-bottom-right-radius: 15px;
  text-align: center;
  z-index: 99;
  font-weight: bold;
  font-size: 36px;
  color: #B76916;
  cursor: pointer;
  box-sizing: border-box;

  &.blue {
    color: #fff;
    border-color: #D5F3FF;
    background: linear-gradient(to bottom, #1DA4EA, #94F2FC);
  }

  &.disabled {
    opacity: 0.6;
    pointer-events: none;
  }
}
</style>
